import mbgImg from "../../assets/img/money-back-guarantee.png";
import mbgImgWebp from "../../assets/img/money-back-guarantee.webp";

type Props = {
    productName: string,
    backgroundClass: string,
};

const MoneyBackGuarantee = ({
    productName,
    backgroundClass,
}: Props) => (
    <section id="money-back-guarantee">
        <div className="container-fluid pb-3">
            <div className="row mt-5 pt-5 justify-content-center align-items-center">
                <div className={`col-md-8 col-11 ${backgroundClass} gg-border-radius`}>
                    <div className="row">
                        <div className="col-lg-3 col-12 text-lg-end text-center ms-lg-3 me-lg-4">
                            <picture>
                                <source srcSet={mbgImgWebp} type="image/webp" />
                                <img className="img-fluid gg-mbg-logo" src={mbgImg} loading="lazy" />
                            </picture>
                        </div>
                        <div className="col-lg-8 mt-3 px-lg-0 px-5 pb-3 text-white text-lg-start text-center">
                            <h3>100% Satisfaction Guaranteed</h3>
                            <h3 className="mb-3">90-Day Money Back Guarantee</h3>
                            <p><span dangerouslySetInnerHTML={{ __html: productName }}></span> comes with a 100% money-back guarantee. 90 full days from your original purchase. If you're not totally and completely satisfied with our product or your results within the first 180 days, simply let us know by dropping us an email, and we'll gladly give you a full refund within 48 hours of the product being returned.</p>
                            <p>That's right! Simply return the product, even your empty bottles, anytime within 90 days of your purchase and you'll receive a full, no-questions-asked refund (minus shipping and handling fees).</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default MoneyBackGuarantee;